
var $ = require('jquery');
var jQuery = $;
var soundManager = require('../node_modules/soundmanager2/script/soundmanager2-nodebug-jsmin.js').soundManager;
var util = require('./creek-util');

Creek.getFrameLog = function(){
  if (typeof window.top.document.Creek != "undefined") {
    return "(window.top.document.Creek)";
  }
  if (typeof window.parent.document.Creek != "undefined") {
    return "(window.top.document.Creek)";
  }
  if (Creek.data.persist.insideIframe) {
    return "(insideIframe)";
  }
  return "(outside frame)";
}

module.exports = {

  soundManager2_url: '',
  player: {}, //placeholder for SM2 object
  selected: null,
  state: null,
  current_player_id: null, //!!!! TODO: make this work
  html: {
    toolbar: {}
  },
  util: {},
  streamUrl: '',

  update: function(data){

    Creek.debug.log("Selecting audio:");
    Creek.debug.log(data);

    if(data.type == 'live'){

      Creek.debug.log('Updating live audio details.');

      //Set up the selected audio
      data.Show = Creek.data.broadcasting.now;
      data.Track = Creek.data.broadcasting.Track;
      Creek.audio.selected = data;

    }
    else if(data.type == 'file'){

      Creek.debug.log('Updating file audio details.');

      //Set up the selected audio
      data.Show = null;
      data.Track = null;
      Creek.audio.selected = data;

    }
    else{
      Creek.debug.log('Warning: Unknown data type in update:', data);
    }

    //Update HTML elements by jQuery method.
    //
    // !!! TODO: update with Vue.js instead.
    //
    $('.creek-live-data .creek-audio-title').html(data.title);
    $('.creek-live-data .creek-audio-link').attr('href', data.originURL);

    if(data.Track){
      $('.creek-live-data .creek-broadcast-link').attr('href', Creek.data.content.getPath("broadcasts", data.Track.broadcast_id));
    }

    //Display the image for the show.
    if(data.Show && data.Show.Image){
      var img_size = Creek.data.audio.toolbar.showImageSize;
      var show_url = Creek.data.shows.prefix+data.Show.short_name;
      $('.creek-audio-show-image img').attr("src", data.Show.Image["url_"+img_size]);
      $('.creek-audio-show-image').attr("href", show_url);
      $('body').addClass("creek-audio-has-show-image");
    }
    else{
      $('body').removeClass("creek-audio-has-show-image");
    }

    Creek.audio.updateTrack(data);

  },
  updateTrack: function(data){

    if(typeof data.Track != 'undefined' && data.Track && typeof data.Track.id != 'undefined'){

      $('.creek-live-data .creek-track-none').fadeOut(function(){

        $('.creek-live-data .creek-track-artist').html(data.Track.artist);
        $('.creek-live-data .creek-track-title').html(data.Track.title);

        //Last, make sure it's faded in, once data in is place.
        $('.creek-live-data .creek-track').fadeIn()

        //!!! TODO: this should use Vue and modify the model
        //!!! TODO later: add the album art to the art CDN in a more permanent way
        $.getJSON("https://art-cdn.creek.fm/api/150/"+encodeURIComponent(data.Track.artist + " - " + data.Track.title), function(data){

          // !!! TESTING
          // console.log("HORSE");
          // console.log(data);

          if(typeof data.errors == "undefined" || typeof data.data != "undefined"){

            // console.log(data.data.url);

            $('.creek-live-data .creek-track-album-art').css("background-image", "url("+data.data.url+")")
        
            $('body').addClass("creek-track-has-album-art");

          }
          else {
            $('body').removeClass("creek-track-has-album-art");
          }

        })

      });

    }
    else{

      $('.creek-live-data .creek-track, .creek-live-data .creek-track-album-art').fadeOut(500, function(){
          $('.creek-live-data .creek-track-none').fadeIn();
      });
      
    }

  },

  setState: {

    // SoundManager2 is loading
    initializing: function(){

      Creek.audio.state = "initializing";

      Creek.debug.log("Audio state: initializing. "+Creek.getFrameLog());

      $("body").addClass('creek-audio-initializing');

    },

    // SoundManager2 is ready (it's "onready()" event fired)
    initialized: function(){

      Creek.audio.state = "initialized";

      Creek.debug.log("Audio state: initialized. "+Creek.getFrameLog());

      $("body").removeClass('creek-audio-initializing');

      Creek.debug.log("Running initialized thing.");
      Creek.data.audio.onInitialized();

    },

    playing: function(){

      Creek.audio.state = "playing";

      Creek.debug.log("Audio state: playing. "+Creek.getFrameLog());

      $("body")
        .addClass('creek-audio-playing')
        .removeClass('creek-audio-loading')
        .removeClass('creek-audio-error');

      //Switch classes on the button
      $(".creek-audio-main-button")
        .removeClass('creek-audio-play-button')
        .addClass('creek-audio-pause-button')
        .removeClass('creek-audio-loading-button');

    },
    paused: function(){

      Creek.audio.state = "paused";

      Creek.debug.log("Audio state: paused. "+Creek.getFrameLog());

      $("body")
        .removeClass('creek-audio-playing')
        .removeClass('creek-audio-loading')
        .removeClass('creek-audio-error');

      //Switch classes on the button
      $(".creek-audio-main-button")
        .addClass('creek-audio-play-button')
        .removeClass('creek-audio-pause-button')
        .removeClass('creek-audio-loading-button');

    },
    // SM2 Sound object is loading/buffering
    loading: function(){

      Creek.audio.state = "loading";

      Creek.debug.log("Audio state: loading. "+Creek.getFrameLog());

      $("body")
        .addClass('creek-audio-loading')
        .removeClass('creek-audio-playing')
        .removeClass('creek-audio-error');

      //Switch classes on the button
      $(".creek-audio-main-button")
        .removeClass('creek-audio-play-button')
        .removeClass('creek-audio-pause-button')
        .addClass('creek-audio-loading-button');

    },
    stopped: function(){

      //Just use the paused state again.
      //TODO: actually have a stop state?
      Creek.audio.setState.paused();

      Creek.debug.log("Audio state: stopped. "+Creek.getFrameLog());

      //!!! Put here since pause updates state as well:
      Creek.audio.state = "playing";

    },
    error: function(){

      $("body")
        .removeClass('creek-audio-playing')
        .removeClass('creek-audio-loading')
        .addClass('creek-audio-error');

      Creek.audio.state = "playing";

      Creek.debug.log("Audio state: error.");

    },

  },

  switchToLive: function(data){

    //!!!!
    //Disabling the iframe communication for now:
    //!!!!
    //
    //Apply this to the window instead, if we're inside the iframe
    if(typeof window.top.document.Creek != "undefined" && Creek.data.persist.insideIframe){
      Creek.debug.log("Applying switchToLive() to parent frame.");
      window.top.document.Creek.audio.switchToLive(e);
      return;
    }

    Creek.debug.log('Switching to live.');

    //Set up broadcasting-based data
    if(Creek.data.broadcasting.now){
      var stream_title = Creek.data.broadcasting.now.title;
      var show_url = Creek.data.shows.prefix + Creek.data.broadcasting.now.short_name || "#"
    }
    else{
      var stream_title = Creek.data.station.station_name;
    }

    //Set up title
    var title = data.title || stream_title;

    //Set up the originURL:
    // The URL from which this current audio content originates.
    // - The current show.
    // - The current audio file (broadcast)
    var originURL = data.originURL || show_url;

    soundManager.stopAll();

    var data_selected = {
      type: "live",
      title: title,
      originURL: originURL,
      Show: Creek.data.broadcasting.now,
      Track: Creek.data.broadcasting.Track
    };

    //Update classes on body
    $("body").addClass('creek-audio-mode-live');
    $("body").removeClass('creek-audio-mode-file');

    Creek.audio.selected = data_selected;

    Creek.debug.log(Creek.audio.selected);
    Creek.debug.log("Origin URL: "+originURL);

    Creek.audio.update(data_selected);

    Creek.audio.setState.stopped();

    $('.creek-audio-switch-to-live').addClass('creek-hide');

  },

  activateInitialLiveAudio: function(Creek){

    var audio_data = {
      type: "live",
      title: "",
      originURL: "#"
    };

    Creek.audio.selected = audio_data;

    Creek.debug.log("Activating initial live audio: "+audio_data);

    Creek.audio.util.resetSpacerHeight();

  },

  showAudioToolbar: function(Creek){

    //Show the audio toolbar
    var tbv = "creek-audio-toolbar-visible";
    if(Creek.data.audio.toolbar.enable && !$('body').hasClass(tbv)){
      Creek.debug.log("Toolbar enabled.")
      $(function(){
        $('body').addClass(tbv);
      });
    }

  },

  switchToFile: function(data){

    var title = data.title || Creek.data.station.title;
    var originURL = data.originURL || "#";

    Creek.audio.update({
      type:"file",
      title: title,
      originURL: originURL
    });

    //Update classes on body
    $("body").addClass('creek-audio-mode-file');
    $("body").removeClass('creek-audio-mode-live');

    Creek.audio.setState.stopped();

    $('.creek-audio-switch-to-live').removeClass('creek-hide');

  },

  util: {

    resetSpacerHeight: function(){
      var h = $('#creek-audio-toolbar').outerHeight() + "px";
      $("#creek-audio-toolbar-spacer").css('height', h);
      $(".creek-audio-toolbar-spacer").css('height', h);
    }

  },

  analytics: {

    startListening: function(){

      //Send Google Analytics event (start)
      Creek.util.GoogleAnalytics('send', 'event', 'play', Creek.audio.selected.type, Creek.audio.selected.title, 1);

      //Start Google Analytics event for listening minutes
      Creek.listenTimer = setInterval(function(){
        Creek.util.GoogleAnalytics('send', 'event', 'listen', Creek.audio.selected.type, Creek.audio.selected.title, 1);
      }, 60000);

      // Creek.debug.log("logging!")
      // console.log(Creek.audio.selected);

    },

    stopListening: function(){

      //Send Google Analytics event (stop)
      Creek.util.GoogleAnalytics('send', 'event', 'stop', Creek.audio.selected.type, Creek.audio.selected.title, 1);

      //Start Google Analytics event for listening
      clearInterval(Creek.listenTimer);

    }


  }

}

Creek.audio = module.exports;



// WEBPACK FOOTER //
// ./src/creek-audio-lib.js